/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { StationPolicy } from 'client-code/channels-service';

import { StationPolicyServiceRepositoryImpl } from '../impls/StationPolicyServiceRepositoryImpl';
import { IStationPolicyServiceRepository } from '../interfaces/IStationPolicyServiceRepository';
import { TServicesParams } from '../types/TServicesParams';

export class StationPolicyService implements IStationPolicyServiceRepository {
    private oStationPolicyServiceRepositoryImpl: StationPolicyServiceRepositoryImpl;

    public constructor(params: TServicesParams) {
        this.oStationPolicyServiceRepositoryImpl = new StationPolicyServiceRepositoryImpl(params);
    }

    public async fetchStationPolicies(): Promise<Array<StationPolicy>> {
        return this.oStationPolicyServiceRepositoryImpl.fetchStationPolicies();
    }
}
